import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

//Shadcn componentleri bu fonksiyonu kullanıyor,silme.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
